import { WidgetPosition } from '@webapp/account/src/resources/survey/addons/widget';

import { ColorScheme, getColor } from '@webapp/common/lib/ui';

export enum ShowWindow {
    BUTTON_CLICK = 'BUTTON_CLICK',
    TIME_INTERVAL = 'TIME_INTERVAL',
}

export interface Popup {
    showWindow: ShowWindow;
    windowTimer: number;
    cancelReopen: boolean;

    closeButtonText: string;
    dontShowButtonText: string;
    executeButtonText: string;

    intervalButtonColor: string;
    intervalButtonTextColor: ColorScheme;
    buttonColor: string;
    buttonTextColor: ColorScheme;
    buttonWidth: number;
    buttonHeight: number;
    buttonBorderColor: string;
    buttonBorderRadius: number;

    popup_opened_position: string;
    popup_opened_width: number;
    popup_opened_height: number;
    popup_opened_radius: number;
    popup_opened_auto_height: boolean;
    mobileDisplay: number;
}

export const initialPopup: Readonly<Popup> = {
    showWindow: ShowWindow.TIME_INTERVAL,
    windowTimer: 10,
    cancelReopen: false,

    closeButtonText: 'Напомнить позже',
    dontShowButtonText: 'Больше не показывать',
    executeButtonText: 'Выполнить опрос',

    intervalButtonColor: getColor('blue'),
    intervalButtonTextColor: ColorScheme.LIGHT,
    buttonColor: getColor('blue'),
    buttonTextColor: ColorScheme.LIGHT,
    buttonWidth: 10,
    buttonHeight: 30,
    buttonBorderColor: getColor('white'),
    buttonBorderRadius: 2,

    popup_opened_position: WidgetPosition.CENTER,
    popup_opened_width: 50,
    popup_opened_height: 50,
    popup_opened_radius: 2,
    popup_opened_auto_height: true,
    mobileDisplay: 1,
};
